import React, {Component} from 'react';
import {IonContent, IonItemDivider, IonItemGroup, IonLabel, IonList, IonSegment, IonSegmentButton} from '@ionic/react';
import "../ContestDetailPage.css"
import {History} from "history";
import Contest from "../../domain/Contest";
import {getTypeImage, getTypeLabel, getTypeOrder, SeriesType} from "../../domain/SeriesType";
import Series from "../../domain/Series";
import SeriesItem from "../../domain/SeriesItem";
import SeriesListItem from "./SeriesListItem";
import {RouteComponentProps} from "react-router";

type Props = RouteComponentProps<{ contestId: string, tab: string }> & {
  history: History;
  contest: Contest;
};

type State = {
  segment: 'all' | SeriesType;
}

export default class ContestDetailInfoTab extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      segment: "all"
    };
  }

  render() {
    const contest = this.props.contest;
    return (
      <>
        <IonContent>
          <div className="contest-detail-series-tab">
            <IonSegment onIonChange={(e: CustomEvent) => this.updateSegment(e)}>
              <IonSegmentButton value="all" checked={this.state.segment === 'all'}>
                Alle
              </IonSegmentButton>
              <IonSegmentButton value="jumping" checked={this.state.segment === 'jumping'}>
                Springen
              </IonSegmentButton>
              <IonSegmentButton value="dressage" checked={this.state.segment === 'dressage'}>
                Dressuur
              </IonSegmentButton>
            </IonSegment>

            {this.renderSeries(contest.series)}
          </div>
        </IonContent>
      </>
    );
  }

  private updateSegment(e: CustomEvent) {
    this.setState(prevState => ({
      ...prevState,
      segment: e.detail.value
    }));
  };

  private renderSeries(series: Series): any {
    const groups = this.groupedByDiscipline(series);
    return (
      <IonList>
        {groups.map((group, index: number) => (
          <IonItemGroup key={`group-${index}`}>
            <IonItemDivider sticky class={"series-list-item"}>
              <IonLabel>
                <img src={getTypeImage(group.type)} alt={getTypeLabel(group.type)}/>
                {getTypeLabel(group.type)}
              </IonLabel>
            </IonItemDivider>
            {group.series.sort((a, b) => a.difficulty.localeCompare(b.difficulty)).map((series: SeriesItem, seriesIndex: number) => (
              <SeriesListItem
                key={`group-${index}-${seriesIndex}`}
                series={series}
                {...this.props}
              />
            ))}
          </IonItemGroup>
        ))}
      </IonList>
    );
  }

  groupedByDiscipline(series: Series) {
    return series
      .filter(item => {
        if (this.state.segment === 'all') {
          return true;
        } else {
          return (this.state.segment === 'dressage' && (item.type === 'dressage' || item.type === 'group-dressage')) ||
            this.state.segment === item.type;
        }
      })
      .sort(this.sortByHour)
      .reduce((groups: { type: SeriesType, series: SeriesItem[] }[], series: SeriesItem) => {
        let type = series.type;
        const foundGroup: any = groups.find(group => group.type === type);
        if (foundGroup) {
          foundGroup.series.push(series);
        } else {
          groups.push({
            type: type,
            series: [series]
          });
        }
        return groups;
      }, [] as { type: SeriesType, series: SeriesItem[] }[])
      .sort((a, b) => getTypeOrder(a.type) - getTypeOrder(b.type));
  }

  groupedByArena(series: Series) {
    return series
      .filter(item => {
        if (this.state.segment === 'all') {
          return true;
        } else {
          return this.state.segment === item.type;
        }
      })
      .sort(this.sortByArena)
      .reduce((groups: { arena: string, series: SeriesItem[] }[], series: SeriesItem) => {
        let arena = series.arena;
        const foundGroup: any = groups.find(group => group.arena === arena);
        if (foundGroup) {
          foundGroup.series.push(series);
        } else {
          groups.push({
            arena: arena,
            series: [series]
          });
        }
        return groups;
      }, [] as { arena: string, series: SeriesItem[] }[]);
  }

  private sortByArena(a: SeriesItem, b: SeriesItem) {
    if (a.arena < b.arena) {
      return -1;
    }
    if (a.arena > b.arena) {
      return 1;
    }
    return 0;
  }

  private sortByHour(a: SeriesItem, b: SeriesItem) {
    const aWeight = (60 * a.startHour) + a.startMinutes;
    const bWeight = (60 * b.startHour) + b.startMinutes;
    if (aWeight < bWeight) {
      return -1;
    }
    if (aWeight > bWeight) {
      return 1;
    }
    return 0;
  }
}
